module.exports = __webpack_public_path__ + "account/assets/2.389cda7c.svg";